import Vue from 'vue';
import Vuex from 'vuex';//vuex本身不是持久化存储，只能通过localStorage sessionStorage Cookie等方式 让它的数据持久化。
//import tabs from './modules/tabs'//手动引入

Vue.use(Vuex);


/**
 * @description 下面代码作用是 导入modules目录下的所有 vuex 模块，自动加入namespaced:true，用于解决vuex命名冲突，请勿修改。
 */
//使用 require.context 方法来"动态"地加载指定文件夹下的模块。这里会加载 ./modules 文件夹下的所有.js 文件，并将它们保存在一个对象 files 中。
const files = require.context('./modules', false, /\.js$/)
const modules = {//模块。每个模块都可以有state,mutations等等，下面写的那些state,mutations其实可以封装到某个模块里面。
    // 可以"手动引入"，也可以"动态"加载modules目录下的每个模块.
    // tabs,手动引入
    // a:{state, mutations,......},手动引入
    // b:{state,mutations,......},手动引入
}
//通过循环遍历 files 对象中的每个模块，将其配置到 Vuex 的 modules 中。
files.keys().forEach((key) => {//动态加载modules目录下的每个模块.
    //console.log(key.replace(/(\.\/|\.js)/g, ''))
    //console.log(files(key).default)
    //key.replace(/(\.\/|\.js)/g, '') 用于去掉模块名中的./和.js部分，然后将该模块设置为当前模块的默认值（.default）,并将其保存到 modules对象中。
    modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
    //console.log(modules)
})
//循环遍历 modules 对象中的每个模块，并为每个模块添加namespaced:true的属性;
// 这样做是为了让每个模块都具有自己的命名空间，以避免不同模块之间发生命名冲突。
Object.keys(modules).forEach((key) => {
    modules[key]['namespaced'] = true
})
/**
 * @description 上面代码作用是 导入modules目录下的所有 vuex 模块，自动加入namespaced:true，用于解决vuex命名冲突，请勿修改。
 */



const store = new Vuex.Store({
    //存数据的地方，类似于data
    state() {
        return {
            testLength: 'ABCDE',
            testCount: 0
        }
    },

    //具有缓存性,类似于computed计算属性
    getters: {
        len(state) {
            console.log('getters的len执行了')//这条只会执行一次
            let result = state.testLength
            return result.length
        }
    },

    //相当于是method,方法函数,主要是用来改state里的数据；
    //组件里面不能直接更改state里面的值，只能通过调用mutations更改。这说明vuex是单向数据流
    mutations: {
        changeTestCount(state, value) {
            state.testCount += value
            console.log('mutation执行了,此时testCount值为:', state.testCount)
        }
    },

    //对mutations再包装一层，可以做异步或延迟操作;可用可不用
    actions: {
        delayChangeTestCount(store, value2) {//延迟
            setTimeout(() => {
                store.commit('changeTestCount', value2)
            }, 3000)//3秒后才执行
            console.log('我在你后面，但是先执行，因为你延迟3秒后才执行')
        }
    },

    modules,
})

export default store